/**
 * Lot BX — bandeau d'un bien supprimé ou archivé (consultation ET édition).
 *
 * 🔴 Ouvert par lien direct, un bien supprimé s'affichait comme n'importe quel autre : on
 * modifiait une fiche invisible du stock sans jamais le savoir.
 *
 * Date/auteur omis s'ils manquent (biens d'avant la traçabilité) — on n'affiche pas « par — ».
 */
import React from 'react';

const PARIS = new Intl.DateTimeFormat('fr-FR', {
  day: '2-digit', month: '2-digit', year: 'numeric',
  hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Paris',
});

const MOTS = {
  deleted: { mot: 'supprimé', classes: 'bg-red-50 border-red-200 text-red-800', icone: 'bi-trash3-fill' },
  archived: { mot: 'archivé', classes: 'bg-slate-100 border-slate-300 text-slate-700', icone: 'bi-archive-fill' },
};

export const BandeauBienInactif = ({ property }) => {
  const statut = property?.status;
  const config = MOTS[statut];
  if (!config) return null;

  const quand = property?.[`${statut}_at`];
  const qui = property?.[`${statut}_by`]?.nom;
  let texte = `Ce bien est ${config.mot}`;
  if (quand) {
    try {
      texte += ` — le ${PARIS.format(new Date(quand)).replace(' ', ' à ')}`;
    } catch {
      // date illisible : on n'affiche rien plutôt qu'une date fausse
    }
  }
  if (qui) texte += `${quand ? '' : ' —'} par ${qui}`;

  return (
    <div
      data-testid={`bandeau-bien-${statut}`}
      role="status"
      className={`w-full px-4 md:px-8 py-2.5 border-b flex items-center gap-2 text-sm font-medium ${config.classes}`}
    >
      <i className={`bi ${config.icone} shrink-0`} />
      <span className="truncate">{texte}</span>
    </div>
  );
};

export default BandeauBienInactif;
